const divFileList = {
  text: 'Eliminar',
  retry: 'Reenviar',
};

export default divFileList;
